import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Heart = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M20.205 4.791a5.938 5.938 0 0 0-4.209-1.754A5.906 5.906 0 0 0 12 4.595a5.904 5.904 0 0 0-3.996-1.558 5.942 5.942 0 0 0-4.213 1.758c-2.353 2.363-2.352 6.059.002 8.412L12 21.414l8.207-8.207c2.354-2.353 2.355-6.049-.002-8.416z", key: "k0" })));
});
Heart.displayName = 'Heart';
export var HeartDimensions = { height: 24, width: 24 };
